import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

export function getRedirectUrl(props) {
  const { app } = props;
  
  if (app === 'file') {
    return;
  }

  return '/';
}

export default function(ComposedComponent) {
  class RequireFileApp extends Component {
    static contextTypes = {
      router: PropTypes.object
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to + window.location.search);
    }

    render() {
      const redirectUrl = getRedirectUrl(this.props);
      if (redirectUrl) {
        this.redirect(redirectUrl);
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {
    return {
      app: state.app.app
    }
  }

  return connect(mapStateToProps)(RequireFileApp);
}
